console.log("contact_form_validation loaded 050525"),
    window.addEventListener("load", function () {
      
const forbiddenWords = [
  "guestpost", "linkbuild", "backlink", "outreach", "blogger", "blogging",
  "highda", "dofollow", "google", "ranked", "domainauthority", "contentwriter", 
  "ranking", "contentwrit", "blogartic", "guestblog", "digitalmarketing",
  "contentcreation", "seooptimization", "seoservice", "monthlyvisitor", 
  "payment", "postlink", "article", "whatsapp"
];

document.querySelectorAll("form").forEach((form) => {
  const submitButton = form.querySelector("button[type='submit'], input[type='submit']");

  form.addEventListener("submit", function (e) {
    const textareas = form.querySelectorAll("textarea");
    let blockSubmission = false;

    textareas.forEach((textarea) => {
      const sanitizedText = textarea.value.toLowerCase().replace(/\s|-/g, "");
      const hasForbiddenWord = forbiddenWords.some(word => sanitizedText.includes(word));
      if (hasForbiddenWord) {
        blockSubmission = true;
      }
    });

    if (blockSubmission) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (submitButton) submitButton.disabled = true;
      console.warn("Form submission blocked due to forbidden words.");
    }
  });

  form.querySelectorAll("textarea").forEach((textarea) => {
    textarea.addEventListener("input", function () {
      const sanitizedText = textarea.value.toLowerCase().replace(/\s|-/g, "");
      const hasForbiddenWord = forbiddenWords.some(word => sanitizedText.includes(word));
      if (submitButton){
        submitButton.disabled = hasForbiddenWord;
        if(hasForbiddenWord)form.remove();
      } 
    });
  });
});

    });
